var render, staticRenderFns
import script from "./CalendarPane.vue?vue&type=script&lang=js&"
export * from "./CalendarPane.vue?vue&type=script&lang=js&"
import style0 from "./CalendarPane.vue?vue&type=style&index=0&id=37fb1233&lang=postcss&scoped=true&"
import style1 from "./CalendarPane.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fb1233",
  null
  
)

export default component.exports